var map = {
	"./da.json": [
		73705,
		"src_assets_i18n_da_json"
	],
	"./de.json": [
		91229,
		"src_assets_i18n_de_json"
	],
	"./en.json": [
		27473,
		"src_assets_i18n_en_json"
	],
	"./fr.json": [
		47946,
		"src_assets_i18n_fr_json"
	],
	"./nl.json": [
		34340,
		"src_assets_i18n_nl_json"
	],
	"./pl.json": [
		28966,
		"src_assets_i18n_pl_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 57995;
module.exports = webpackAsyncContext;